import { render, staticRenderFns } from "./FundModalInform.vue?vue&type=template&id=64744ab0&"
import script from "./FundModalInform.vue?vue&type=script&lang=js&"
export * from "./FundModalInform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports